import { render, staticRenderFns } from "./ExtendedBadgeForm.vue?vue&type=template&id=26fa2128&"
import script from "./ExtendedBadgeForm.vue?vue&type=script&lang=js&"
export * from "./ExtendedBadgeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports